<template>
  <div>
    <div style="width: 100%;height: 32px;"></div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
      <el-form-item label="待支付清除时间（分钟）：" prop="cancelUnOrderPayNumber">
        <el-input style="width: 424px;" v-model="ruleForm.cancelUnOrderPayNumber" placeholder="请输入待支付清除时间,单位分钟"></el-input>
        <div class="mt-system-warm">说明：待支付订单，系统自动清除时间</div>
      </el-form-item>
      <el-form-item label="自动收货时间（天）：" prop="autoConfirmOrderNumber">
        <el-input style="width: 424px;" v-model="ruleForm.autoConfirmOrderNumber" placeholder="请输入自动收货时间,单位天"></el-input>
        <div class="mt-system-warm">说明：发货订单，用户未收货，系统自动收货时间</div>
      </el-form-item>
      <el-form-item label="售后保护时间（天）：" prop="orderOverDateNumber">
        <el-input style="width: 424px;" v-model="ruleForm.orderOverDateNumber" placeholder="请输售后保护时间,单位天"></el-input>
        <div class="mt-system-warm">说明：收货订单，在多长时间内可以申请售后</div>
      </el-form-item>
      <!-- <el-form-item label="是否开启自动推送：" prop="enableAutoDelivery">
        <el-select style="width: 424px;" v-model="ruleForm.enableAutoDelivery" placeholder="请选择">
          <el-option
            v-for="item in enableAutoDeliveryArr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="同城配送推送平台：" prop="deliveryType">
        <el-select style="width: 424px;" v-model="ruleForm.deliveryType" placeholder="请选择">
          <el-option
            v-for="item in deliveryTypeArr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="退货收件人：" prop="refundConsigneeName">
        <el-input style="width: 424px;" v-model="ruleForm.refundConsigneeName" placeholder="请输入退货收件人"></el-input>
      </el-form-item>
      <el-form-item label="退货联系方式：" prop="refundConsigneePhone">
        <el-input style="width: 424px;" v-model="ruleForm.refundConsigneePhone" placeholder="请输入退货联系方式"></el-input>
      </el-form-item>
      <el-form-item label="退货地址：" prop="refundConsigneeAddress">
        <el-input style="width: 424px;" v-model="ruleForm.refundConsigneeAddress" placeholder="请输入退货地址"></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="首充返现比例：" prop="firstRechargeCommissionRate">
        <el-input style="width: 424px;" v-model="ruleForm.firstRechargeCommissionRate" placeholder="请输首充返现给推荐人比例"></el-input>
      </el-form-item> -->
      <el-form-item label="关于我们：" prop="aboutDesc">
        <editor :value="ruleForm.aboutDesc" :height="350" v-model="ruleForm.aboutDesc"></editor>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { infoWatch, update } from '@/api/setting'
import Editor from '@/components/Editor.vue'
export default {
  name: 'System',
  components: {
    Editor
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      enableAutoDeliveryArr:[{
        label:'手动推送',
        value:0
      },{
        label:'自动推送',
        value:1
      }],
      deliveryTypeArr:[{
        label:'推送到自配系统',
        value:1
      },{
        label:'推送到达达平台',
        value:2
      },{
        label:'不推送',
        value:100
      }],
      ruleForm: {
        cancelUnOrderPayNumber:'',
        autoConfirmOrderNumber:'',
        orderOverDateNumber:'',
        aboutDesc:''
      },
      rules: {
        cancelUnOrderPayNumber: [
          { required: true, message: '请输入待支付清除时间,单位分钟', trigger: 'blur' }
        ],
        autoConfirmOrderNumber: [
          { required: true, message: '请输入自动收货时间,单位天', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    var that = this;
    infoWatch({}).then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          that.ruleForm = data;
        }
    })
  },
  methods: {
    // 保存操作
    saveBtn () {
      let that = this
      let ruleForm = that.ruleForm
      if(ruleForm.cancelUnOrderPayNumber == ''){
        this.$message.error('请输入待支付清除时间,单位分钟')
        return false
      }
      if(ruleForm.autoConfirmOrderNumber == ''){
        this.$message.error('请输入自动收货时间,单位天')
        return false
      }
      that.fullscreenLoading = true
      update(ruleForm).then((res) => {
        that.fullscreenLoading = false
        if (res.errorCode === '0000') {
          this.$message({
            message: res.msg,
            type: 'success',
            onClose () {
              that.$router.go(0)
            }
          })
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/setting/components/ManagementSystem.vue